import React from 'react';
import classnames from 'classnames';
import './TimeSlotEntry.scss';

class TimeSlotEntry extends React.Component {
  displayTime (StartTime) {
    const BaseTime = new Date(StartTime * 1000);
    BaseTime.setHours(0, 0, 0, 0);
    const time = (StartTime - (BaseTime.getTime() / 1000)) / 60;

    if (this.props.display24Hour) {
      const hour = (time - (time % 60)) / 60;
      const mins = time - (hour * 60);
      return `${hour}:${('0' + mins).slice(-2)}`;
    } else {
      let hour = (time - (time % 60)) / 60;
      let mins = time - (hour * 60);
      let postfix = (hour > 11) ? 'pm' : 'am';

      if (hour === 0) {
        hour = 12;
      }

      if (hour > 12) {
        hour = hour - 12;
      }

      return `${hour}:${('0' + mins).slice(-2)}${postfix}`;
    }
  }

  render () {
    return (
      <div className={classnames({
        'TimeEntry': true,
        'clearfix': true,
        'TimeEntry--ConfirmRequest': this.props.confirm
      })}>
        <div className='TimeEntry__TimeWrap' onClick={this.props.select(this.props.StartTime)}>
          {this.displayTime(this.props.StartTime) + ' - ' + this.displayTime(this.props.StartTime + (this.props.meetingLength * 60))}
        </div>
        <div className='TimeEntry__ConfirmButton' onClick={this.props.onChange(this.props.StartTime)}>
          <a>Confirm</a>
        </div>
        <div className='TimeEntry__RejectButton' onClick={this.props.select(null)}>
          <a>Cancel</a>
        </div>
      </div>
    );
  }
}

export default TimeSlotEntry;



// WEBPACK FOOTER //
// ./src/routes/scheduler/routes/SelectSlot/components/TimeSlotEntry/index.js